var React = require('react');

function PlusFilled (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M17.9464 0.000445585H21.0526C23.032 0.000445585 24.6515 1.6199 24.6515 3.59926V14.3505H35.4011C37.3805 14.3505 39 15.9699 39 17.9493V21.0554C39 23.0348 37.3805 24.6543 35.4011 24.6543L24.6498 24.65V35.4012C24.6498 37.3805 23.0303 39 21.0509 39H17.9448C15.9654 39 14.3459 37.3805 14.3459 35.4012L14.3502 24.65H3.59886C1.61947 24.65 0 23.0305 0 21.0512V17.945C0 15.9656 1.61947 14.3462 3.59886 14.3462H14.3485L14.3507 3.59882C14.3507 1.61945 15.968 0 17.9474 0L17.9464 0.000445585Z","fill":"black"}));
}

PlusFilled.defaultProps = {"width":"39","height":"39","viewBox":"0 0 39 39","fill":"none"};

module.exports = PlusFilled;

PlusFilled.default = PlusFilled;
